import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("leve_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [checkoutTick, setCheckoutTick] = useState(0);
  const [coupon, setCoupon] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("leve_coupon")) || null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    localStorage.setItem("leve_coupon", JSON.stringify(coupon));
  }, [coupon]);

  useEffect(() => {
    localStorage.setItem("leve_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1, variant = null) => {
    const key = product.slug + (variant?.name ? `::${variant.name}` : "");
    const item = {
      ...product,
      key,
      variant_name: variant?.name || null,
      sku: variant?.sku || null,
      image: variant?.image || product.image,
      price: variant?.sale_price ?? variant?.price ?? product.price,
      stock: variant?.stock ?? product.stock,
    };
    setItems((prev) => {
      const found = prev.find((i) => (i.key || i.slug) === key);
      if (found) return prev.map((i) => ((i.key || i.slug) === key ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { ...item, qty }];
    });
    setOpen(true);
  };

  const buyNow = (product, qty = 1, variant = null) => {
    add(product, qty, variant);
    setCheckoutTick((t) => t + 1);
  };

  const setQty = (key, qty) => {
    if (qty <= 0) return setItems((prev) => prev.filter((i) => (i.key || i.slug) !== key));
    setItems((prev) => prev.map((i) => ((i.key || i.slug) === key ? { ...i, qty } : i)));
  };

  const clear = () => setItems([]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);
  const total = useMemo(() => items.reduce((s, i) => s + i.qty * i.price, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, buyNow, setQty, clear, count, total, open, setOpen, checkoutTick, coupon, setCoupon }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);

export const brl = (v) => v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
